function Footer() {
  return (
    <div className="flex flex-col justify-end items-center footer rounded-md h-16 sm:h-24 md:h-40 pb-1 sm:pb-2 md:pb-4 lg:pb-5">
      <div className="footer-text sm:text-xs md:text-sm text-white">&copy; 2021 Expat Immo. All rights reserved</div>
    </div>
  );
}

export default Footer;
